import { useClientConfig } from '@framework/auth/client-config/ClientConfigSlice.tsx';
import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import { FrontFooterLogo } from './FrontFooterLogo.tsx';

export const ContentTitle = styled.h2`
  /* font-size: 27px;
  line-height: 27px; */
  font-weight: 600;
  color: ${props => props.theme.layoutFooterColor};
  margin-top: 27px;
  padding-bottom: 24px;
  border-bottom: 1px solid #979797;
  margin-bottom: 24px;
  font-size: 24px;
  line-height: 1;
  /* text-transform: uppercase; */
`;
export const ContentLink = styled.h2`
  /* font-size: 27px;
  line-height: 27px; */
  font-weight: 600;
  color: ${props => props.theme.layoutFooterColor};
  margin-top: 14px;
  /* padding-bottom: 16px; */
  margin-bottom: 14px;
  font-size: 20px;
  line-height: 1;
  a {
    color: ${props => props.theme.layoutFooterLinkColor};
    text-decoration: underline;
    &:hover {
      color: ${props => props.theme.layoutFooterLinkHoverColor};
    }
  }
`;
export const ContentTextLine = styled.div`
  /* font-size: 18px; */
  font-size: 16px;

  line-height: 1.5;
  font-weight: 400;
  color: ${props => props.theme.layoutFooterColor};
  strong {
    font-weight: 600;
  }
  a {
    color: ${props => props.theme.layoutFooterLinkColor};
    text-decoration: underline;
    &:hover {
      color: ${props => props.theme.layoutFooterLinkHoverColor};
    }
  }
`;
export const ContentFiscalCode = styled(ContentTextLine)`
  border-top: 1px solid #979797;
  padding-top: 24px;
  margin-top: 54px;
  text-align: center;
`;

export interface IFrontFooterContentProps {}
/**
 * Contenuto testuale e link del footer.
 */
export function FrontFooterContent(props: IFrontFooterContentProps) {
  const { jsonConfig } = useClientConfig();

  return (
    <div>
      {/* prima riga */}
      <Row gutter={60}>
        <Col sm={24} md={16}>
          <VerticalSpace size={27} />
          <FrontFooterLogo />
          <ContentLink>
            <a href="https://wwwservizi.regione.emilia-romagna.it/cercaregione/DettaglioStruttura.aspx?Xlzs5azsfkA/8GHXHKnLn8hTF1+12NBc9RmFaxGYlgq32vAsd9wiwpNvO/MvRbPk">
              Direzione generale cura del territorio e dell&apos;ambiente
            </a>
          </ContentLink>
          <ContentTextLine>Viale Aldo Moro, 30</ContentTextLine>
          <ContentTextLine>40127 Bologna</ContentTextLine>
        </Col>
        <Col sm={24} md={8}>
          <ContentTitle>Link utili</ContentTitle>
          <ContentTextLine>
            <a
              href={
                jsonConfig?.urlInformazioneCrediti ??
                'https://ambiente.regione.emilia-romagna.it/it/info'
              }
              rel="noopener noreferrer"
            >
              Informazioni e crediti
            </a>
          </ContentTextLine>
          <ContentTextLine>
            <a
              href={
                jsonConfig?.urlContatti ??
                'mailto:Ambiente@Regione.Emilia-Romagna.it'
              }
            >
              Contatti
            </a>
          </ContentTextLine>
        </Col>
      </Row>
      <VerticalSpace size={27} />
      {/* seconda riga */}
      <Row gutter={60}>
        {/* Prima colonna */}
        <Col sm={24} md={8}>
          <ContentTitle>Recapiti</ContentTitle>
          <ContentTextLine>
            <strong>Regione Emilia-Romagna</strong>
          </ContentTextLine>
          <ContentTextLine>Viale Aldo Moro, 52</ContentTextLine>
          <ContentTextLine>40127 Bologna</ContentTextLine>
          <ContentTextLine>
            <strong>Centralino</strong> <a href="tel:+39.0515271">051 5271</a>
          </ContentTextLine>
          <ContentTextLine>
            <a href="https://wwwservizi.regione.emilia-romagna.it/Cercaregione/Default.aspx?cons=0">
              Cerca telefoni o indirizzi
            </a>
          </ContentTextLine>
        </Col>
        {/* Seconda colonna */}
        <Col sm={24} md={8}>
          <ContentTitle>URP</ContentTitle>
          <ContentTextLine>
            <strong>Sito web: </strong>
            <a href="https://www.regione.emilia-romagna.it/urp">
              www.regione.emilia-romagna.it/urp
            </a>
          </ContentTextLine>
          <ContentTextLine>
            <strong>Numero verde: </strong>
            <a href="tel:+39.800662200">800.66.22.00</a>
          </ContentTextLine>
          <ContentTextLine>
            <strong>Scrivici: </strong>
            <a href="mailto:urp@regione.emilia-romagna.it">e-mail</a> -{' '}
            <a href="mailto:urp@postacert.regione.emilia-romagna.it">PEC</a>
          </ContentTextLine>
        </Col>
        {/* Terza colonna */}
        <Col sm={24} md={8}>
          <ContentTitle>Trasparenza</ContentTitle>
          {/* <ContentTextLine>
            <Link to={'/area-pubblica' as BrandedPath}>Area Pubblica</Link>
          </ContentTextLine> */}
          <ContentTextLine>
            <a
              rel="noopener noreferrer"
              href={
                jsonConfig?.urlAmministrazione ??
                'https://trasparenza.regione.emilia-romagna.it'
              }
            >
              Amministrazione trasparente
            </a>
          </ContentTextLine>
          <ContentTextLine>
            <a
              rel="noopener noreferrer"
              href={
                jsonConfig?.urlCopyright ??
                'https://www.regione.emilia-romagna.it/note-legali'
              }
            >
              Note legali e copyright
            </a>
          </ContentTextLine>
          <ContentTextLine>
            <a
              id="v_privacy_link"
              rel="noopener noreferrer"
              href={
                jsonConfig?.urlPrivacyPolicy ??
                'https://ambiente.regione.emilia-romagna.it/it/privacy'
              }
            >
              Privacy e Cookies
            </a>
          </ContentTextLine>
          <ContentTextLine>
            <a
              id="v_a11y_link"
              rel="noopener noreferrer"
              href={
                jsonConfig?.urlAccessibilita ??
                'https://ambiente.regione.emilia-romagna.it/it/accessibilita'
              }
            >
              Dichiarazione di accessibilità
            </a>
          </ContentTextLine>
        </Col>
      </Row>
      <ContentFiscalCode>C.F. 800.625.903.79</ContentFiscalCode>
    </div>
  );
}
